module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box box-default color-palette-box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('row', _vm._l((_vm.colors[0]), function(color) {
    return _c('va-color-palette-set', {
      attrs: {
        "color": color
      }
    })
  })), _vm._v(" "), _c('row', _vm._l((_vm.colors[1]), function(color) {
    return _c('va-color-palette-set', {
      attrs: {
        "color": color
      }
    })
  }))], 1)]), _vm._v(" "), _c('h2', {
    staticClass: "page-header"
  }, [_vm._v("Alerts and Callouts")]), _vm._v(" "), _c('row', [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "box box-default"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('i', {
    staticClass: "fa fa-warning"
  }), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Alerts")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('va-alert', {
    attrs: {
      "type": "danger",
      "dismissible": true
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('h4', [_c('i', {
    staticClass: "icon fa fa-ban"
  }), _vm._v(" Alert!")])]), _vm._v(" "), _c('div', {
    slot: "body"
  }, [_vm._v("\n              Danger alert preview. This alert is dismissable. A wonderful serenity has taken possession of my entire\n              soul, like these sweet mornings of spring which I enjoy with my whole heart.\n            ")])]), _vm._v(" "), _c('va-alert', {
    attrs: {
      "type": "info",
      "dismissible": true
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('h4', [_c('i', {
    staticClass: "icon fa fa-info"
  }), _vm._v(" Alert!")])]), _vm._v(" "), _c('div', {
    slot: "body"
  }, [_vm._v("\n              Info alert preview. This alert is dismissable.\n            ")])]), _vm._v(" "), _c('va-alert', {
    attrs: {
      "type": "warning",
      "dismissible": true
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('h4', [_c('i', {
    staticClass: "icon fa fa-warning"
  }), _vm._v(" Alert!")])]), _vm._v(" "), _c('div', {
    slot: "body"
  }, [_vm._v("\n              Warning alert preview. This alert is dismissable.\n            ")])]), _vm._v(" "), _c('va-alert', {
    attrs: {
      "type": "success",
      "dismissible": true
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('h4', [_c('i', {
    staticClass: "icon fa fa-check"
  }), _vm._v(" Alert!")])]), _vm._v(" "), _c('div', {
    slot: "body"
  }, [_vm._v("\n              Success alert preview. This alert is dismissable.\n            ")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "box box-default"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('i', {
    staticClass: "fa fa-bullhorn"
  }), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Callouts")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('va-callout', {
    attrs: {
      "type": "danger",
      "title": "I am a danger callout!",
      "text": "There is a problem that we need to fix. A wonderful serenity has taken possession of my entire soul, like these sweet mornings of spring which I enjoy with my whole heart."
    }
  }), _vm._v(" "), _c('va-callout', {
    attrs: {
      "type": "info",
      "title": "I am an info callout!",
      "text": "Follow the steps to continue to payment."
    }
  }), _vm._v(" "), _c('va-callout', {
    attrs: {
      "type": "warning",
      "title": "I am a warning callout!",
      "text": "This is a yellow callout."
    }
  }), _vm._v(" "), _c('va-callout', {
    attrs: {
      "type": "success",
      "title": "I am a success callout!",
      "text": "This is a green callout."
    }
  })], 1)])])]), _vm._v(" "), _c('h2', {
    staticClass: "page-header"
  }, [_vm._v("AdminLTE Custom Tabs")]), _vm._v(" "), _c('row', [_c('div', {
    staticClass: "col-md-6"
  }, [_c('va-custom-tab', [_c('li', {
    staticClass: "dropdown",
    slot: "nav"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "data-toggle": "dropdown",
      "href": "#"
    }
  }, [_vm._v("\n                                  Dropdown "), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "role": "menuitem",
      "tabindex": "-1",
      "href": "#"
    }
  }, [_vm._v("Action")])]), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "role": "menuitem",
      "tabindex": "-1",
      "href": "#"
    }
  }, [_vm._v("Another action")])]), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "role": "menuitem",
      "tabindex": "-1",
      "href": "#"
    }
  }, [_vm._v("Something else here")])]), _vm._v(" "), _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "presentation"
    }
  }), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "role": "menuitem",
      "tabindex": "-1",
      "href": "#"
    }
  }, [_vm._v("Separated link")])])])]), _vm._v(" "), _c('li', {
    staticClass: "pull-right",
    slot: "nav"
  }, [_c('a', {
    staticClass: "text-muted",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-gear"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "active",
    attrs: {
      "id": "tab_1",
      "title": "Tab 1"
    },
    slot: "content"
  }, [_c('b', [_vm._v("How to use:")]), _vm._v(" "), _c('p', [_vm._v("Exactly like the original bootstrap tabs except you should use the custom wrapper "), _c('code', [_vm._v(".nav-tabs-custom")]), _vm._v(" to achieve this style.")]), _vm._v("\n          A wonderful serenity has taken possession of my entire soul, like these sweet mornings of spring which I enjoy with my whole heart. I am alone, and feel the charm of existence in this spot, which was created for the bliss of souls like mine. I am so happy, my dear friend, so absorbed in the exquisite sense of mere tranquil existence, that I neglect my talents. I should be incapable of drawing a single stroke at the present moment; and yet I feel that I never was a greater artist than now.\n        ")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "tab_2",
      "title": "Tab 2"
    },
    slot: "content"
  }, [_vm._v("\n          The European languages are members of the same family. Their separate existence is a myth. For science, music, sport, etc, Europe uses the same vocabulary. The languages only differ in their grammar, their pronunciation and their most common words. Everyone realizes why a new common language would be desirable: one could refuse to pay expensive translators. To achieve this, it would be necessary to have uniform grammar, pronunciation and more common words. If several languages coalesce, the grammar of the resulting language is more simple and regular than that of the individual languages.\n        ")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "tab_3",
      "title": "Tab 3"
    },
    slot: "content"
  }, [_vm._v("\n          Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.\n        ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('va-custom-tab', {
    attrs: {
      "tabsClass": "pull-right"
    }
  }, [_c('li', {
    staticClass: "dropdown",
    slot: "nav"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "data-toggle": "dropdown",
      "href": "#"
    }
  }, [_vm._v("\n            Dropdown "), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "role": "menuitem",
      "tabindex": "-1",
      "href": "#"
    }
  }, [_vm._v("Action")])]), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "role": "menuitem",
      "tabindex": "-1",
      "href": "#"
    }
  }, [_vm._v("Another action")])]), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "role": "menuitem",
      "tabindex": "-1",
      "href": "#"
    }
  }, [_vm._v("Something else here")])]), _vm._v(" "), _c('li', {
    staticClass: "divider",
    attrs: {
      "role": "presentation"
    }
  }), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "role": "menuitem",
      "tabindex": "-1",
      "href": "#"
    }
  }, [_vm._v("Separated link")])])])]), _vm._v(" "), _c('li', {
    staticClass: "pull-left header",
    slot: "nav"
  }, [_c('i', {
    staticClass: "fa fa-th"
  }), _vm._v(" Custom Tabs")]), _vm._v(" "), _c('div', {
    staticClass: "active",
    attrs: {
      "id": "tab_1",
      "title": "Tab 1"
    },
    slot: "content"
  }, [_c('b', [_vm._v("How to use:")]), _vm._v(" "), _c('p', [_vm._v("Exactly like the original bootstrap tabs except you should use the custom wrapper "), _c('code', [_vm._v(".nav-tabs-custom")]), _vm._v(" to achieve this style.")]), _vm._v("\n          A wonderful serenity has taken possession of my entire soul, like these sweet mornings of spring which I enjoy with my whole heart. I am alone, and feel the charm of existence in this spot, which was created for the bliss of souls like mine. I am so happy, my dear friend, so absorbed in the exquisite sense of mere tranquil existence, that I neglect my talents. I should be incapable of drawing a single stroke at the present moment; and yet I feel that I never was a greater artist than now.\n        ")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "tab_2",
      "title": "Tab 2"
    },
    slot: "content"
  }, [_vm._v("\n          The European languages are members of the same family. Their separate existence is a myth. For science, music, sport, etc, Europe uses the same vocabulary. The languages only differ in their grammar, their pronunciation and their most common words. Everyone realizes why a new common language would be desirable: one could refuse to pay expensive translators. To achieve this, it would be necessary to have uniform grammar, pronunciation and more common words. If several languages coalesce, the grammar of the resulting language is more simple and regular than that of the individual languages.\n        ")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "tab_3",
      "title": "Tab 3"
    },
    slot: "content"
  }, [_vm._v("\n          Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.\n        ")])])], 1)]), _vm._v(" "), _c('h2', {
    staticClass: "page-header"
  }, [_vm._v("Progress Bars")]), _vm._v(" "), _c('row', [_c('div', {
    staticClass: "col-md-6"
  }, [_c('va-box', {
    attrs: {
      "title": "Progress Bars Different Sizes",
      "isSolid": true,
      "widgetType": ""
    }
  }, [_c('div', {
    slot: "content"
  }, [_c('p', [_c('code', [_vm._v(".progress")])]), _vm._v(" "), _c('va-progress-bar', {
    attrs: {
      "type": "primary",
      "max": 100,
      "value": 40,
      "text": "40% Complete (success)"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Class: "), _c('code', [_vm._v(".sm")])]), _vm._v(" "), _c('va-progress-bar', {
    attrs: {
      "type": "success",
      "size": "sm",
      "max": 100,
      "value": 20,
      "isActive": true,
      "text": "20% Complete"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Class: "), _c('code', [_vm._v(".xs")])]), _vm._v(" "), _c('va-progress-bar', {
    attrs: {
      "type": "warning",
      "size": "xs",
      "max": 100,
      "value": 60,
      "text": "60% Complete (warning)"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Class: "), _c('code', [_vm._v(".xxs")])]), _vm._v(" "), _c('va-progress-bar', {
    attrs: {
      "type": "danger",
      "size": "xxs",
      "max": 100,
      "value": 60,
      "text": "60% Complete (danger)"
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('va-box', {
    attrs: {
      "title": "Progress bars",
      "isSolid": true,
      "widgetType": ""
    }
  }, [_c('div', {
    slot: "content"
  }, [_c('va-progress-bar', {
    attrs: {
      "type": "green",
      "isStriped": false,
      "max": 100,
      "value": 40,
      "text": "40% Complete (success)"
    }
  }), _vm._v(" "), _c('va-progress-bar', {
    attrs: {
      "type": "aqua",
      "isStriped": false,
      "max": 100,
      "value": 20,
      "text": "20% Complete"
    }
  }), _vm._v(" "), _c('va-progress-bar', {
    attrs: {
      "type": "yellow",
      "isStriped": false,
      "max": 100,
      "value": 60,
      "text": "60% Complete (warning)"
    }
  }), _vm._v(" "), _c('va-progress-bar', {
    attrs: {
      "type": "red",
      "isStriped": false,
      "max": 100,
      "value": 80,
      "text": "80% Complete"
    }
  })], 1)])], 1)]), _vm._v(" "), _c('row', [_c('div', {
    staticClass: "col-md-6"
  }, [_c('va-box', {
    attrs: {
      "title": "Vertical Progress Bars Different Sizes",
      "isSolid": true,
      "widgetType": ""
    }
  }, [_c('div', {
    staticClass: "text-center",
    slot: "content"
  }, [_c('p', [_vm._v("By adding the class "), _c('code', [_vm._v(".vertical")]), _vm._v(" and "), _c('code', [_vm._v(".progress-sm")]), _vm._v(", "), _c('code', [_vm._v(".progress-xs")]), _vm._v(" or\n            "), _c('code', [_vm._v(".progress-xxs")]), _vm._v(" we achieve:")]), _vm._v(" "), _c('va-progress-bar', {
    attrs: {
      "type": "primary",
      "max": 100,
      "value": 40,
      "isActive": true,
      "isVertical": true,
      "text": "40%"
    }
  }), _vm._v(" "), _c('va-progress-bar', {
    attrs: {
      "type": "success",
      "size": "sm",
      "max": 100,
      "value": 20,
      "isActive": true,
      "isVertical": true,
      "text": "20%"
    }
  }), _vm._v(" "), _c('va-progress-bar', {
    attrs: {
      "type": "warning",
      "size": "xs",
      "max": 100,
      "value": 60,
      "isActive": true,
      "isVertical": true,
      "text": "60%"
    }
  }), _vm._v(" "), _c('va-progress-bar', {
    attrs: {
      "type": "info",
      "size": "xxs",
      "max": 100,
      "value": 60,
      "isActive": true,
      "isVertical": true,
      "text": "60%"
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('va-box', {
    attrs: {
      "title": "Vertical Progress bars",
      "isSolid": true,
      "widgetType": ""
    }
  }, [_c('div', {
    staticClass: "text-center",
    slot: "content"
  }, [_c('p', [_vm._v("By adding the class "), _c('code', [_vm._v(".vertical")]), _vm._v(" we achieve:")]), _vm._v(" "), _c('va-progress-bar', {
    attrs: {
      "type": "green",
      "max": 100,
      "value": 40,
      "isStriped": false,
      "isVertical": true,
      "text": "40%"
    }
  }), _vm._v(" "), _c('va-progress-bar', {
    attrs: {
      "type": "aqua",
      "max": 100,
      "value": 20,
      "isStriped": false,
      "isVertical": true,
      "text": "20%"
    }
  }), _vm._v(" "), _c('va-progress-bar', {
    attrs: {
      "type": "yellow",
      "max": 100,
      "value": 60,
      "isStriped": false,
      "isVertical": true,
      "text": "60%"
    }
  }), _vm._v(" "), _c('va-progress-bar', {
    attrs: {
      "type": "red",
      "max": 100,
      "value": 60,
      "isStriped": false,
      "isVertical": true,
      "text": "60%"
    }
  })], 1)])], 1)]), _vm._v(" "), _c('h2', {
    staticClass: "page-header"
  }, [_vm._v("Bootstrap Accordion & Carousel")]), _vm._v(" "), _c('row', [_c('div', {
    staticClass: "col-md-6"
  }, [_c('va-box', {
    attrs: {
      "title": "Collapsible Accordion",
      "isSolid": true,
      "widgetType": ""
    }
  }, [_c('div', {
    staticClass: "text-center",
    slot: "content"
  }, [_c('va-accordion', {
    attrs: {
      "list": _vm.accordion.list
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('va-box', {
    attrs: {
      "title": "Carousel",
      "isSolid": true,
      "widgetType": ""
    }
  }, [_c('div', {
    slot: "content"
  }, [_c('va-carousel', {
    attrs: {
      "name": _vm.carousel.name,
      "list": _vm.carousel.list
    }
  })], 1)])], 1)]), _vm._v(" "), _c('h2', {
    staticClass: "page-header"
  }, [_vm._v("Typography")]), _vm._v(" "), _c('row', [_c('div', {
    staticClass: "col-md-6"
  }, [_c('va-box', {
    attrs: {
      "title": "Headlines",
      "isSolid": true,
      "widgetType": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-text-width",
    slot: "icon-title"
  }), _vm._v(" "), _c('div', {
    slot: "content"
  }, [_c('h1', [_vm._v("h1. Bootstrap heading")]), _vm._v(" "), _c('h2', [_vm._v("h2. Bootstrap heading")]), _vm._v(" "), _c('h3', [_vm._v("h3. Bootstrap heading")]), _vm._v(" "), _c('h4', [_vm._v("h4. Bootstrap heading")]), _vm._v(" "), _c('h5', [_vm._v("h5. Bootstrap heading")]), _vm._v(" "), _c('h6', [_vm._v("h6. Bootstrap heading")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('va-box', {
    attrs: {
      "title": "Text Emphasis",
      "isSolid": true,
      "widgetType": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-text-width",
    slot: "icon-title"
  }), _vm._v(" "), _c('div', {
    slot: "content"
  }, [_c('va-text', [_vm._v("\n            Lead to emphasize importance\n          ")]), _vm._v(" "), _c('va-text', {
    attrs: {
      "type": "green"
    }
  }, [_vm._v("\n            Text green to emphasize success\n          ")]), _vm._v(" "), _c('va-text', {
    attrs: {
      "type": "aqua"
    }
  }, [_vm._v("\n            Text aqua to emphasize info\n          ")]), _vm._v(" "), _c('va-text', {
    attrs: {
      "type": "light-blue"
    }
  }, [_vm._v("\n            Text light blue to emphasize info (2)\n          ")]), _vm._v(" "), _c('va-text', {
    attrs: {
      "type": "red"
    }
  }, [_vm._v("\n            Text red to emphasize danger\n          ")]), _vm._v(" "), _c('va-text', {
    attrs: {
      "type": "yellow"
    }
  }, [_vm._v("\n            Text yellow to emphasize warning\n          ")]), _vm._v(" "), _c('va-text', {
    attrs: {
      "type": "muted"
    }
  }, [_vm._v("\n            Text muted to emphasize general\n          ")])], 1)])], 1)]), _vm._v(" "), _c('row', [_c('div', {
    staticClass: "col-md-6"
  }, [_c('va-box', {
    attrs: {
      "title": "Block Quotes",
      "isSolid": true,
      "widgetType": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-text-width",
    slot: "icon-title"
  }), _vm._v(" "), _c('div', {
    slot: "content"
  }, [_c('blockquote', [_c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.")]), _vm._v(" "), _c('small', [_vm._v("Someone famous in "), _c('cite', {
    attrs: {
      "title": "Source Title"
    }
  }, [_vm._v("Source Title")])])])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('va-box', {
    attrs: {
      "title": "Block Quotes Pulled Right",
      "isSolid": true,
      "widgetType": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-text-width",
    slot: "icon-title"
  }), _vm._v(" "), _c('div', {
    slot: "content"
  }, [_c('blockquote', {
    staticClass: "pull-right"
  }, [_c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer posuere erat a ante.")]), _vm._v(" "), _c('small', [_vm._v("Someone famous in "), _c('cite', {
    attrs: {
      "title": "Source Title"
    }
  }, [_vm._v("Source Title")])])])], 1)])], 1)]), _vm._v(" "), _c('row', [_c('div', {
    staticClass: "col-md-4"
  }, [_c('va-box', {
    attrs: {
      "title": "Unordered Lists",
      "isSolid": true,
      "widgetType": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-text-width",
    slot: "icon-title"
  }), _vm._v(" "), _c('div', {
    slot: "content"
  }, [_c('ul', [_c('li', [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('li', [_vm._v("Consectetur adipiscing elit")]), _vm._v(" "), _c('li', [_vm._v("Integer molestie lorem at massa")]), _vm._v(" "), _c('li', [_vm._v("Facilisis in pretium nisl aliquet")]), _vm._v(" "), _c('li', [_vm._v("Nulla volutpat aliquam velit\n              "), _c('ul', [_c('li', [_vm._v("Phasellus iaculis neque")]), _vm._v(" "), _c('li', [_vm._v("Purus sodales ultricies")]), _vm._v(" "), _c('li', [_vm._v("Vestibulum laoreet porttitor sem")]), _vm._v(" "), _c('li', [_vm._v("Ac tristique libero volutpat at")])])]), _vm._v(" "), _c('li', [_vm._v("Faucibus porta lacus fringilla vel")]), _vm._v(" "), _c('li', [_vm._v("Aenean sit amet erat nunc")]), _vm._v(" "), _c('li', [_vm._v("Eget porttitor lorem")])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('va-box', {
    attrs: {
      "title": "Ordered Lists",
      "isSolid": true,
      "widgetType": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-text-width",
    slot: "icon-title"
  }), _vm._v(" "), _c('div', {
    slot: "content"
  }, [_c('ol', [_c('li', [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('li', [_vm._v("Consectetur adipiscing elit")]), _vm._v(" "), _c('li', [_vm._v("Integer molestie lorem at massa")]), _vm._v(" "), _c('li', [_vm._v("Facilisis in pretium nisl aliquet")]), _vm._v(" "), _c('li', [_vm._v("Nulla volutpat aliquam velit\n              "), _c('ol', [_c('li', [_vm._v("Phasellus iaculis neque")]), _vm._v(" "), _c('li', [_vm._v("Purus sodales ultricies")]), _vm._v(" "), _c('li', [_vm._v("Vestibulum laoreet porttitor sem")]), _vm._v(" "), _c('li', [_vm._v("Ac tristique libero volutpat at")])])]), _vm._v(" "), _c('li', [_vm._v("Faucibus porta lacus fringilla vel")]), _vm._v(" "), _c('li', [_vm._v("Aenean sit amet erat nunc")]), _vm._v(" "), _c('li', [_vm._v("Eget porttitor lorem")])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('va-box', {
    attrs: {
      "title": "Unstyled Lists",
      "isSolid": true,
      "widgetType": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-text-width",
    slot: "icon-title"
  }), _vm._v(" "), _c('div', {
    slot: "content"
  }, [_c('ul', {
    staticClass: "list-unstyled"
  }, [_c('li', [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('li', [_vm._v("Consectetur adipiscing elit")]), _vm._v(" "), _c('li', [_vm._v("Integer molestie lorem at massa")]), _vm._v(" "), _c('li', [_vm._v("Facilisis in pretium nisl aliquet")]), _vm._v(" "), _c('li', [_vm._v("Nulla volutpat aliquam velit\n              "), _c('ul', [_c('li', [_vm._v("Phasellus iaculis neque")]), _vm._v(" "), _c('li', [_vm._v("Purus sodales ultricies")]), _vm._v(" "), _c('li', [_vm._v("Vestibulum laoreet porttitor sem")]), _vm._v(" "), _c('li', [_vm._v("Ac tristique libero volutpat at")])])]), _vm._v(" "), _c('li', [_vm._v("Faucibus porta lacus fringilla vel")]), _vm._v(" "), _c('li', [_vm._v("Aenean sit amet erat nunc")]), _vm._v(" "), _c('li', [_vm._v("Eget porttitor lorem")])])])])], 1)]), _vm._v(" "), _c('row', [_c('div', {
    staticClass: "col-md-6"
  }, [_c('va-box', {
    attrs: {
      "title": "Description",
      "isSolid": true,
      "widgetType": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-text-width",
    slot: "icon-title"
  }), _vm._v(" "), _c('div', {
    slot: "content"
  }, [_c('dl', [_c('dt', [_vm._v("Description lists")]), _vm._v(" "), _c('dd', [_vm._v("A description list is perfect for defining terms.")]), _vm._v(" "), _c('dt', [_vm._v("Euismod")]), _vm._v(" "), _c('dd', [_vm._v("Vestibulum id ligula porta felis euismod semper eget lacinia odio sem nec elit.")]), _vm._v(" "), _c('dd', [_vm._v("Donec id elit non mi porta gravida at eget metus.")]), _vm._v(" "), _c('dt', [_vm._v("Malesuada porta")]), _vm._v(" "), _c('dd', [_vm._v("Etiam porta sem malesuada magna mollis euismod.")])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('va-box', {
    attrs: {
      "title": "Description Horizontal",
      "isSolid": true,
      "widgetType": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-text-width",
    slot: "icon-title"
  }), _vm._v(" "), _c('div', {
    slot: "content"
  }, [_c('dl', {
    staticClass: "dl-horizontal"
  }, [_c('dt', [_vm._v("Description lists")]), _vm._v(" "), _c('dd', [_vm._v("A description list is perfect for defining terms.")]), _vm._v(" "), _c('dt', [_vm._v("Euismod")]), _vm._v(" "), _c('dd', [_vm._v("Vestibulum id ligula porta felis euismod semper eget lacinia odio sem nec elit.")]), _vm._v(" "), _c('dd', [_vm._v("Donec id elit non mi porta gravida at eget metus.")]), _vm._v(" "), _c('dt', [_vm._v("Malesuada porta")]), _vm._v(" "), _c('dd', [_vm._v("Etiam porta sem malesuada magna mollis euismod.")]), _vm._v(" "), _c('dt', [_vm._v("Felis euismod semper eget lacinia")]), _vm._v(" "), _c('dd', [_vm._v("Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo\n              sit amet risus.\n            ")])])])])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-tag"
  }), _vm._v(" Color Palette")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-068ad110!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ui-elements/General.vue
// module id = 491
// module chunks = 1